import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AgentWallet`;


const ApiWallet = {

  getAgentWalletByUserId: (params) => {
    const url = `${baseServiceUrl}/getAgentWalletByUserId`;
    return ServiceApi.get(url);

  },

};

export default ApiWallet;


